export default __webpack_public_path__ + "assets/png/e3e493c94c70a59792991e18483dd234.png";